import { motion } from "motion/react";
import { useState } from "react";

export const LandingSection = () => {
  const data = [
    {
      title: "Portfolio Under Development",
      image:
        // "https://res.cloudinary.com/dimrfrbqw/image/upload/v1760442623/myimage_y4jciz.jpg",
        "https://dummyimage.com/900x1600/ac16f2/ac16f2",
    },
    {
      title: "Portfolio Under Development",
      image: "https://dummyimage.com/900x1600/ac16f2/ac16f2",
    },
    {
      title: "Portfolio Under Development",
      image: "https://dummyimage.com/900x1600/ac16f2/ac16f2",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="flex items-center justify-start gap-5 h-full w-full p-5">
      {data.map((item, index) => (
        <motion.div
          key={index}
          onClick={() => setActiveIndex(activeIndex === index ? null : index)}
          className={`cursor-pointer rounded-2xl select-none bg-cover bg-center h-[65%]`}
          style={{ backgroundImage: `url(${item.image})` }}
          whileHover={{
            scale: 1.01,
            transition: { duration: 0.1 },
            filter: "grayscale(0%)",
          }}
          initial={{
            opacity: 0,
            x: 100,
            filter: "grayscale(50%)",
            aspectRatio: "9/16",
          }}
          whileInView={{
            opacity: 1,
            x: 0,
            transition: {
              duration: 1.5,
              delay: index * 0.5,
              ease: "easeInOut",
            },
          }}
          viewport={{ once: true }}
          animate={{
            aspectRatio: activeIndex === index ? "16/9" : "9/16",
            filter: activeIndex === index ? "grayscale(0%)" : "grayscale(50%)",
          }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <p className="h-full w-full flex items-end justify-center bg-black/5 text-white text-4xl font-bold uppercase rounded-2xl p-2 text-center">
            {item.title}
          </p>
        </motion.div>
      ))}
    </div>
  );
};
